import styles from "../../styles/portfolioManagerDashboard.module.scss";

const S = ({ style = {} }) => (
  <div className={styles.skeletonBlock} style={style} />
);

export const StatCardSkeleton = () => (
  <div className={styles.skeletonCard}>
    <S style={{ width: "55%", height: 12 }} />
    <S style={{ width: "65%", height: 52, borderRadius: 8 }} />
    <div className={styles.skeletonBarTrack}>
      <S style={{ width: "60%", height: "100%", borderRadius: 3 }} />
    </div>
    <S style={{ width: "50%", height: 10 }} />
  </div>
);

export const BudgetCostCardSkeleton = () => (
  <div className={`${styles.skeletonCard} ${styles.skeletonCardWide}`}>
    <S style={{ width: "40%", height: 12 }} />
    <S style={{ width: "100%", height: 120, borderRadius: 8, flex: 1 }} />
  </div>
);

export const PortfoliosPanelSkeleton = () => (
  <div className={styles.skeletonPanel}>
    <div className={styles.skeletonGrid5x5}>
      {Array.from({ length: 5 }).map((_, i) => (
        <div className={`${styles.skeletonCard} ${styles.skeletonCardWide}`}>
          <S style={{ width: "40%", height: 12 }} />
          <S style={{ width: "100%", height: 120, borderRadius: 8, flex: 1 }} />
        </div>
      ))}
    </div>
  </div>
);

export const ValuePanelSkeleton = () => (
  <div className={styles.skeletonPanel}>
    <div className={styles.skeletonRow}>
      <S style={{ width: 160, height: 14 }} />
      <S style={{ width: 80, height: 26, borderRadius: 8, marginLeft: "auto" }} />
    </div>
    <div className={styles.skeletonRow} style={{ flex: 1, minHeight: 220, alignItems: "stretch" }}>
      <S style={{ flex: "1 1 60%", height: "100%", borderRadius: 10 }} />
      <S style={{ flex: "0 0 38%", height: "100%", borderRadius: 10 }} />
    </div>
  </div>
);

export const RiskMapPanelSkeleton = () => (
  <div className={styles.skeletonPanel}>
    <S style={{ width: 120, height: 14 }} />
    <div className={styles.skeletonGrid5x5}>
      {Array.from({ length: 25 }).map((_, i) => (
        <div key={i} className={styles.skeletonGridCell} />
      ))}
    </div>
  </div>
);

export const CapacityPanelSkeleton = () => (
  <div className={styles.skeletonPanel}>
    <S style={{ width: 160, height: 14 }} />
    <div className={styles.skeletonBarsRow}>
      {Array.from({ length: 12 }).map((_, i) => (
        <S
          key={i}
          style={{
            flex: 1,
            height: `${40 + Math.sin(i) * 30 + 30}px`,
            borderRadius: 6,
          }}
        />
      ))}
    </div>
  </div>
);

export const TablePanelSkeleton = () => (
  <div className={styles.skeletonPanel} style={{ overflow: "hidden" }}>
    <S style={{ width: 140, height: 14 }} />
    {Array.from({ length: 6 }).map((_, i) => (
      <div key={i} className={styles.skeletonTableRow}>
        <S style={{ width: 28, height: 28, borderRadius: 6, flexShrink: 0 }} />
        <S style={{ flex: 2, height: 12 }} />
        <S style={{ flex: 1, height: 12 }} />
        <S style={{ flex: 1, height: 12 }} />
        <S style={{ flex: 1, height: 12 }} />
      </div>
    ))}
  </div>
);

// ─── Full Dashboard Skeleton ──────────────────────────────
export const DashboardSkeleton = () => (
  <>
    <div className="flex gap-3 w-full mb-3">
      <StatCardSkeleton />
      <StatCardSkeleton />
      <StatCardSkeleton />
      <StatCardSkeleton />
      <BudgetCostCardSkeleton />
    </div>

    <div className="row align-items-stretch">
      <div className="col-12 mb-3">
        <PortfoliosPanelSkeleton />
      </div>

    </div>

    <div className="row align-items-stretch">
      <div className="col-8 mb-3">
        <ValuePanelSkeleton />
      </div>
      <div className="col-4 mb-3">
        <RiskMapPanelSkeleton />
      </div>
    </div>

    <div className="row mb-3">
      <div className="col-12 mb-3 d-flex flex-column" style={{ height: 400 }}>
        <CapacityPanelSkeleton />
      </div>
    </div>
  </>
);
